import { useQuery } from "@tanstack/react-query";
import DostupnostService from "./DostupnostService";
import type { Dostupnost } from "../generated/models/Dostupnost";

export const useDostupnostJednotkyQuery = () => {
    return useQuery<Dostupnost[], Error>({
        queryKey: ['dostupnostJednotky'],
        queryFn: () => DostupnostService.getDostupnostJednotky(),
        staleTime: 30 * 1000,
        refetchOnWindowFocus: true,
        refetchInterval: 30000,
    });
};

export const useDostupnostHistorieQuery = (uzivatelId: number) => {
    return useQuery<Dostupnost[], Error>({
        queryKey: ['dostupnostHistorie', uzivatelId],
        queryFn: () => DostupnostService.getDostupnostHistorie(uzivatelId),
        enabled: !!uzivatelId,
    });
};

export const useHzsSmenaAktualniQuery = () => {
    return useQuery<{ currentShift: string }, Error>({
        queryKey: ['hzsSmenaAktualni'],
        queryFn: () => DostupnostService.getHzsSmenaAktualni(),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
    });
};
